import * as fabric from 'office-ui-fabric-react';
import React, { FC } from 'react';

const HomePage: FC = () => {
    return (
        <div
            style={{ backgroundColor: fabric.getTheme().palette.themePrimary, minHeight: '60vh', width: '100%', textAlign: 'center' }}
            className="homePage"
            dir="ltr"
        >
            <div className="ms-slideRightIn40" style={{ padding: '80px' }}>
                <fabric.Text
                    style={{ fontSize: '50px', fontWeight: 'lighter', color: 'white', paddingTop: '40px', marginTop: '40px' }}
                    variant="xxLargePlus"
                >
                    Eilių valdymo sistemos
                </fabric.Text>

                <br />
                <fabric.Text style={{ fontSize: '90px', color: 'white' }} variant="xLarge">
                    NUGIS
                </fabric.Text>
                <br />
                <fabric.Text style={{ fontSize: '50px', fontWeight: 'lighter', color: 'white' }} variant="xLarge">
                    portalas
                </fabric.Text>
            </div>
        </div>
    );
};

export default HomePage;
